import { render } from "./medicalRecord.vue?vue&type=template&id=f5f1910c&scoped=true"
import script from "./medicalRecord.vue?vue&type=script&lang=js"
export * from "./medicalRecord.vue?vue&type=script&lang=js"

import "./medicalRecord.vue?vue&type=style&index=0&id=f5f1910c&scoped=true&lang=css"

import exportComponent from "D:\\svn test\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5f1910c"]])

export default __exports__